<template>
  <div class="prod-box__wrap">
    <figure class="prod-box__figure">
      <a class="prod-box__zoom" :href="product.imageUrl" max-width="1182px" data-lightbox="product-lightbox"
         :data-title="`${product.name} ${sku}`" rel="product_images">
        <svg data-v-54a3f4="">
          <use xlink:href="#icon-search-light"></use>
        </svg>
      </a>
      <img class="prod-box__img" :src="product.thumbnailUrl" :alt="product.name"/>
      <div class="premium-icon__wrap">
        <div v-if="product.isPremium" class="premium-icon">
          <svg class="premium-icon__icon">
            <use xlink:href="#icon-gem-solid"></use>
          </svg>
          <p class="premium-icon__text">Premium</p>
        </div>
        <div v-if="product.isHistoricImage" class="premium-icon">
          <svg class="premium-icon__icon">
            <use xlink:href="#icon-folder-open-regular"></use>
          </svg>
          <p class="premium-icon__text">From The Archive</p>
        </div>
      </div>
    </figure>
    <a :href="product.productUrl">
      <div class="prod-box__overlay">
        <div class="prod-box__text-wrap">
          <h2 class="prod-box__title">
            {{ product.name }}
          </h2>
          <p class="prod-box__subtitle">{{ sku }}</p>
        </div>
      </div>
    </a>
  </div>
</template>

<script setup lang="ts">
import {Product} from "../../utils/types.ts";
import {computed, ComputedRef} from "vue";

interface Props {
  product: Product;
}

const props = defineProps<Props>()

const sku: ComputedRef<string> = computed(()=>{
  return props.product.sku ? props.product.sku.split('-').slice(1).join('-') : ""
})


</script>
